// @flow
import * as React from 'react';

import s from './DropDownLazy.scss';
import PickListItem from '../PickListItem/PickListItem.jsx';
import Input from '../Input/Input.jsx';
import Spinner from '../Spinner/Spinner.jsx';
import TriangleDown from '../images/triangle-down.svg';
import SearchIcon from '../images/search.svg';
import ClearSearchBtn from '../images/close-search.svg';

type Props = {
  disabled: boolean,
  width: number,
  label: string,
  items: {id: number, name: string}[],
  selectedId: number,
  onItemClick: (id: number) => void,
  onSearchChange: (val: string) => void,
  onSearch: (val: string) => void,
  searchQuery: string,
  onScroll: (e: SyntheticEvent<any>) => void,
  fetching: boolean,
}

type State = {
  dropDownOpen: boolean,
}


export class DropDownLazy extends React.PureComponent<Props, State> {
  state = {
    dropDownOpen: false,
  }

  render() {
    const { label, width, disabled } = this.props;
    const { dropDownOpen } = this.state;
    const modalStyle = this.getModalStyle();

    return (
      <div>
        <div className={modalStyle.join(' ')}>
          <div
            className={s.header_wrapper}
            style={{width}}
          >
            { !dropDownOpen && this.renderHeader() }
            { dropDownOpen && this.renderSearch() }
            { !disabled && this.renderChevron() }
          </div>
          { this.renderDropdown() }
        </div>
        { dropDownOpen && this.renderModalBg() }
      </div>
    )
  }



  ///////////////////////////////////////////////////////////////////////
  //  RENDER METHODS
  ///////////////////////////////////////////////////////////////////////

  renderHeader() {
    const { width, disabled } = this.props;

    return (
      <button
        onClick={() => this.onHeaderClick()}
        style={{width}}
        className={[s.header2, s.map_btn].join(' ')}
        disabled={disabled}
      >
        { this.renderLabel() }
      </button>
    )
  }

  renderLabel() {
    const { items, selectedId, label } = this.props;
    let header = `Select a ${label}`;

    if (selectedId === -1) {
      return header;
    } else {
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].id === selectedId) {
          return items[i].name;
        }
      }
    }
    return header;
  }

  renderChevron() {
    return (
      <img
        className={[s.chevron, s.triangle].join(' ')}
        onClick={() => this.onHeaderClick()}
        src={TriangleDown}
        alt="down triangle"
      />
    )
  }

  renderSearch() {
    const { searchQuery, disabled, label } = this.props;

    return (
      <div className={s.search_container}>
        <img
          src={SearchIcon}
          alt="search"
          className={s.search_icon}
          onClick={() => this.onSearchClick()}
        />
        <Input
          label=''
          value={searchQuery}
          name='search'
          placeholder={`Search...`}
          disabled={disabled}
          hasError={false}
          onKeyUp={(e) => this.onInputChange(e)}
          onChange={(e) => this.onInputChange(e)}
        />
        {
          searchQuery !== '' &&
          <img
            src={ClearSearchBtn}
            alt="clearSearch"
            className={s.clear_search_icon}
            onClick={() => this.onClearSearchClick()}
          />
        }
    </div>
    )
  }

  renderDropdown() {
    const { width, onScroll, fetching } = this.props;

    return (
      <div className={s.selection_wrapper}>
        <ul
          id="container"
          className={s.selection_container}
          style={{width}}
          onScroll={onScroll}
        >
          { this.renderItems() }
        </ul>
        <Spinner
          left={'20%'}
          top={'73px'}
          fontSize={'2em'}
          visible={fetching}
        />
      </div>
    )
  }

  renderItems() {
    const { items, selectedId } = this.props;
    if (!items) return [];

    return (items.map(item => {
      const selected = selectedId === item.id;
      return (
        <div id={selected ? "selected" : null} key={item.id}>
          <PickListItem
            name={item.name}
            selected={selected}
            disabled={false}
            onItemClick={ ()=> this.onProcessItemClick(item.id) }
          />
        </div>
      )
    }): any[])
  }

  renderModalBg() {
    return (
      <div
        className={s.modal_bg}
        onClick={() => {this.setState({ dropDownOpen: false })} }
      >
      </div>
    )
  }

  ///////////////////////////////////////////////////////////////////////
  //  UTIL METHODS
  ///////////////////////////////////////////////////////////////////////
  getModalStyle() {
    let style = [s.body];
    if (this.state.dropDownOpen) {
      style = [s.body, s.open];
    } else {
      style = [s.body, s.closed];
    }
    return style
  }


  ///////////////////////////////////////////////////////////////////////
  //  EVENT HANDLERS
  ///////////////////////////////////////////////////////////////////////


  onHeaderClick() {
    const dropDownOpen = this.state.dropDownOpen ? false : true;
    this.setState({ dropDownOpen });

    if (dropDownOpen) {
      const scrollInterval = setInterval(() => {
        const container = document.getElementById('container');
        if (container) {
          this.scrollToElement(container);
          clearInterval(scrollInterval);
        }
      }, 50)
    }

  }

  onProcessItemClick(i: number) {
    this.setState({ dropDownOpen: false });
    this.props.onItemClick(i);
  }

  scrollToElement(container: HTMLElement ) {
    let selectedItem = document.getElementById('selected');

    if (container && selectedItem) {
      container.scrollTop = selectedItem.offsetTop;
    }
  }

  onInputChange(e: any) {
    e.preventDefault();
    const query = e.currentTarget.value;
    this.props.onSearchChange(query);

    if (e.keyCode === 13) {
      this.props.onSearch(query);
    }
  }

  onSearchClick() {
    this.props.onSearch(this.props.searchQuery);
  }

  onClearSearchClick() {
    this.props.onSearchChange('');
    this.props.onSearch('');
  }


}




export default DropDownLazy
